// src/pages/LandingPage.js
import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import SocialFooter from '../components/SocialFooter'
import './LandingPage.css'

const TIERS = [
  {
    id: 'gold',
    tier: 'Tier 1',
    name: 'Gold',
    subtitle: 'The Admirer',
    labelClass: 'badge--gold',
    features: [
      { text: 'One personal Q&A session per week', active: true },
      { text: '24-hour live chat window per session', active: true },
      { text: 'Timer starts on your first message', active: true },
      { text: '4 sessions per month (1 per week)', active: true },
      { text: 'Zangi & private number — visible, not accessible', active: true },
      { text: 'Unlimited messaging — Premium & above', active: false },
      { text: 'Voice call — Platinum only', active: false },
      { text: 'Dinner booking — Platinum only', active: false },
    ],
  },
  {
    id: 'premium',
    tier: 'Tier 2',
    name: 'Premium',
    subtitle: 'The Companion',
    labelClass: 'badge--premium',
    featured: true,
    features: [
      { text: 'Everything in Gold', active: true },
      { text: 'Unlimited chat — message anytime', active: true },
      { text: 'Zangi messaging — fully unlocked', active: true },
      { text: 'Private number texting — unlocked', active: true },
      { text: 'All contact platforms visible & accessible', active: true },
      { text: 'Voice call — Platinum only', active: false },
      { text: 'Dinner booking — Platinum only', active: false },
    ],
  },
  {
    id: 'platinum',
    tier: 'Tier 3',
    name: 'Platinum',
    subtitle: 'The Intimate Circle',
    labelClass: 'badge--platinum',
    features: [
      { text: 'Everything in Premium', active: true },
      { text: 'Unlimited chat — highest priority', active: true },
      { text: 'Live voice calls — free, built-in', active: true },
      { text: 'Private one-on-one dinner booking', active: true },
      { text: 'You cover only the dinner bill', active: true },
      { text: 'Zangi + private number — fully unlocked', active: true },
      { text: 'All platforms & contacts — full access', active: true },
    ],
  },
]

export default function LandingPage() {
  return (
    <div className="landing page-enter">
      <Navbar />

      {/* HERO */}
      <section className="hero">
        <div className="hero__glow" />
        <div className="container--narrow">
          <p className="hero__eyebrow">Private Members Platform</p>
          <h1 className="hero__name">
            Skylar Brianna<br />
            <em>Harrison</em>
          </h1>
          <p className="hero__aka">Popularly known as <strong>Sky Bri</strong></p>
          <div className="hero__divider" />
          <p className="hero__desc">
            A curated, intimate space for those who want more than content.
            Real access. Real connection. Choose your card.
          </p>
          <div className="hero__btns">
            <Link to="/join" className="btn btn--gold">Get Your Lover's Card</Link>
            <Link to="/login" className="btn btn--outline">Member Login</Link>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="stats">
        <div className="container">
          <div className="stats__grid">
            <div className="stats__item">
              <span className="stats__val">2.5M+</span>
              <span className="stats__lbl">Instagram Followers</span>
            </div>
            <div className="stats__item">
              <span className="stats__val">1M+</span>
              <span className="stats__lbl">OnlyFans Subscribers</span>
            </div>
            <div className="stats__item">
              <span className="stats__val">LA, CA</span>
              <span className="stats__lbl">Based In</span>
            </div>
            <div className="stats__item">
              <span className="stats__val">3 Tiers</span>
              <span className="stats__lbl">Levels of Access</span>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="about">
        <div className="container--narrow">
          <p className="section-eyebrow">About Sky Bri</p>
          <h2 className="section-title">More Than a Model</h2>
          <p className="about__text">
            Born February 21, 1999 in Lancaster, Pennsylvania — I moved to Los Angeles to live life on my own terms.
            Model. Content creator. Adult film actress. Playboy Plus feature. No Jumper collaborator.
            I built my platform from the ground up, and this space is the most personal layer of it all.
            Only a select few get real access to me — this is yours.
          </p>
        </div>
      </section>

      {/* TIERS */}
      <section className="tiers">
        <div className="container">
          <p className="section-eyebrow text-center">The Lover's Card</p>
          <h2 className="section-title text-center">Choose Your Level</h2>
          <p className="section-sub text-center">Each card is attached permanently to your profile</p>

          <div className="tiers__grid">
            {TIERS.map(t => (
              <div key={t.id} className={`tier-card tier-card--${t.id} ${t.featured ? 'tier-card--featured' : ''}`}>
                {t.featured && <div className="tier-card__top-badge">Most Popular</div>}
                <div className="tier-card__header">
                  <span className={`badge ${t.labelClass}`}>{t.tier}</span>
                  <h3 className={`tier-card__name tier-card__name--${t.id}`}>{t.name}</h3>
                  <p className="tier-card__subtitle">{t.subtitle}</p>
                </div>
                <ul className="tier-card__features">
                  {t.features.map((f, i) => (
                    <li key={i} className={`tier-card__feature ${f.active ? 'active' : 'inactive'}`}>
                      <span className={`tier-card__dot ${f.active ? 'dot--on' : 'dot--off'}`} />
                      {f.text}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/join?tier=${t.id}`}
                  className={`btn btn--full ${t.id === 'gold' ? 'btn--outline' : t.id === 'premium' ? 'btn--gold' : 'btn--plat'}`}
                >
                  Join as {t.name}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SocialFooter />
    </div>
  )
}
